
import { ModalController, ViewController,NavParams } from 'ionic-angular';

import { Component } from '@angular/core';
import { NavController, AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';


import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { UploadService } from '../../../services/upload-service';
import { Upload } from '../../../services/upload';

declare var cordova: any;

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ProgressBarComponent } from '../../../components/progress-bar/progress-bar';
import * as firebase from "firebase";

@Component({
    selector: 'page-videorecorder',
    templateUrl: 'video-recorder.html'
})
export class VideoRecorderForm {

    lastImage: string = null;

    term: any;
    jobList: any;
    loading: Loading;
    currently_loading: any = false;
    uploadTask: any;
    mission: any;
    file_extensions : string = ".png, .jpg, .jpeg, .doc, .docx, .pdf, .rtf";
    allowed_file_type : string = "video/mp4,video/x-m4v,video/*";

    constructor(
        public storage: Storage,
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,
        private camera: Camera,
        public actionSheetCtrl: ActionSheetController,
        public toastCtrl: ToastController,
        public platform: Platform,
        public loadingCtrl: LoadingController,
        public uploadService: UploadService

    ) {
        //this.jobList = this.uiData.jobList();
        this.mission=params.get('mission');


    }

    public onFileFromStorageChosen(filesEvent: any) {
        this.processFileFromStorage(filesEvent);
    }
    public processFileFromStorage(event: any) {
        let file = event.target.files[0];
        //you can read various properties of the file (like mimetype and size) from the file object.
        this.readfile(file);
    }
    public readfile(file: any): void {
        this.uploadTask = new Upload(file);
        this.uploadTask.document_type = "video";
        this.uploadTask.specific_root='users/'+this.userData.token+'/missionCandidates/'+this.mission.id;
        var that = this;
        this.uploadService.pushUpload(this.uploadTask).on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot: any) =>  {
            },
            (error) => {
            },
            () => {
                that.userData.update('missionCandidates/'+that.mission.id,'video_uploaded',1);
                let prompt = this.alertCtrl.create({
                    title: 'Validation des documents',
                    message: "Votre présentation vidéo a été envoyée. Elle va être traitée et vérifiée par nos équipes. Vous pourrez ensuite la trouver à tout moment dans L'espace \"Mon compte\".",
                    buttons: [
                        {
                            text: "Fermer",
                            handler: data => {

                                that.dismiss();
                            }
                        }
                    ]
                });
                prompt.present();
            }
        );
        /*console.log("push upload");
        let reader = new FileReader();
        var newFileName = this.createFileName(file.name);
        reader.onload = (e) => {
            let dataUrl = reader.result;
            //and do something with the reader.
            //this.setLoading(true,"Traitement du fichier...");
        };*/

        //reader.readAsDataURL(file);
    }

    private presentToast(text) {
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    ngAfterViewInit() {

    }
    dismiss() {
        this.viewCtrl.dismiss(this.uploadTask);
    }

    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/video-recorder/video-recorder.ts